var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00537109H513V341.987H0V-0.00537109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00537109H513V113.992H0V-0.00537109Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 227.99H513V341.987H0V227.99Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.145 131.652L277.528 144.269C282.909 149.651 286.238 157.086 286.238 165.298C286.238 181.722 272.923 195.036 256.5 195.036C240.076 195.036 226.762 181.721 226.762 165.298C226.762 157.087 230.091 149.651 235.472 144.269L222.856 131.652C214.245 140.263 208.918 152.158 208.918 165.297C208.918 191.576 230.221 212.879 256.5 212.879C282.779 212.879 304.082 191.576 304.082 165.297C304.082 152.159 298.756 140.263 290.145 131.652Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 147.455L260.929 161.087H275.261L263.666 169.511L268.095 183.142L256.5 174.717L244.904 183.142L249.334 169.511L237.738 161.087H252.07L256.5 147.455Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00927734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPy);
export default __webpack_public_path__ + "static/media/PY.9641470a361b1282cd04c205e8bd6e40.svg";
export { ForwardRef as ReactComponent };